<template>
  <div class="categroyDialog-container">
    <el-dialog title="分类" :visible="showCategoryDialog" width="400px" @close="btnCancel">
      <template>
        <span class="cate-item" v-for="cateItem in customCateList" :key="cateItem.shopDecorateId" @click="cateItemclick(cateItem.shopDecorateId)">{{
          cateItem.name
        }}</span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { getGoodsShopCategory } from "@/api/publishGoods/publishGoods";
import { goodsShopClassifyAdd } from "@/api/manageGoods/manageGoods";

export default {
  props: {
    showCategoryDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      spuIds: [],
      customCateId: "",
      customCateList: [],
    };
  },
  created() {
    this.loadGetGoodsShopCategory();
  },
  methods: {
    async loadGetGoodsShopCategory() {
      const result = await getGoodsShopCategory();
      this.customCateList = result.data;
    },
    async cateItemclick(shopDecorateId) {
      try {
        const result = await goodsShopClassifyAdd({ shopDecorateId, spuIds: this.spuIds });
        if (result.code == 0) {
          this.$message.success("设置分类成功");
          //成功则,先刷新后关闭
          this.$emit("reloadspuList");
          this.$emit("update:showCategoryDialog", false);
        } else {
          this.$message.error(result.msg || "设置分类失败");
        }
      } catch (error) {
        this.$message.error("设置分类失败");
      }
    },
    btnCancel() {
      this.$emit("update:showCategoryDialog", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.categroyDialog-container {
  ::v-deep .el-dialog__header {
    border-bottom: 1px solid lightgray;
  }
  ::v-deep .el-dialog__body {
    padding: 15px 15px 25px 15px;
  }
  .cate-item {
    display: inline-block;
    margin-right: 15px;
    margin-top: 15px;
    color: #909399;
    cursor: pointer;
    &:hover {
      color: #1890ff;
    }
  }
}
</style>
